import { axiosInstance } from "../axios/axiosConfig";
import { FAQ_API } from "../constants/api-constants";

export const getFaqCategories = async () => {
  const res = await axiosInstance.get(`${FAQ_API.GET_FAQ_SECTION}`);
  return res.data?.data || [];
};

export const getFaqCategoriesInUsed = async () => {
  const res = await axiosInstance.get(`${FAQ_API.GET_FAQ_SECTION_IN_USED}`);
  return res.data;
};

export const getFaqsByCategory = async (filter, categoryId = null, search = null) => {
  const postBody = {
    ...filter,
    GlobalFilter: categoryId ?? search,
    GlobalFilterKeys: categoryId ? ["sectionId"] : ["sectionName"],
  };

  const res = await axiosInstance.post(`${FAQ_API.GET_FAQ_LIST}`, postBody);
  return res.data;
};